<template>
    <section class="hero is-success is-fullheight">
        <div class="hero-body">
            <div class="container">
                <h1 class="title">
                    Nicht erlaubt
                </h1>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "PageUnauthorized"
    }
</script>

<style scoped>

</style>
